import { useToastNotification } from 'utils/hooks/useToastNotification';

import { useTranslation } from '../../../hooks/useTranslation';
import { useConditionState } from '../useConditionState';

export const useFieldFacetsErrorToast = (didError: boolean) => {
  const { t } = useTranslation();
  const [{ field }] = useConditionState();
  useToastNotification({
    negative: true,
    enabled: didError,
    negativeMessage: t('apiError.fieldFacets', { field }),
  });
};
